export enum PrintTypeEnum {
    Fiscal = 0 ,
    Thermal = 1
}